/**
 * Utility functions for handling contact exports
 */

import { message } from "antd";
import { api } from "../../../api";
import { buildUIFilters } from "./filterUtils";

/**
 * Get export actions based on customer type
 */
export const getExportActions = (
  userMail,
  customer,
  filterGroups = [],
  selectedSegment = null,
) => {
  const messageContent =
    "Your data is exporting... We will send you an email with a link to download the file.";
  const exportActions = [
    {
      label: "Export all contacts",
      onClick: async () => {
        message.loading(messageContent);

        const customerId = customer.id;

        if (customer.shouldEncryptPI) {
          await api.exportEncryptedCustomerAllContacts({
            customerId,
            userEmail: userMail,
            isFromExportButton: true,
          });
        } else {
          await api.exportAllContacts({
            customerId,
            userEmail: userMail,
          });
        }
      },
    },
  ];

  const isLockedSegment = selectedSegment?.type === "static";

  // Add "Export selected contacts" option when filters are applied, or when
  // a locked segment is selected (its membership is a fixed phone-number
  // list rather than filters - see exportAllContacts.js's segmentId branch).
  if (filterGroups.length > 0 || isLockedSegment) {
    exportActions.push({
      label: "Export selected contacts",
      onClick: async () => {
        message.loading(messageContent);

        const customerId = customer.id;

        // A locked segment's membership must not be re-derived from filters
        // (it may have drifted since creation) - export it by segmentId so
        // the backend exports the exact snapshotted contacts instead.
        const targetParams = isLockedSegment
          ? { segmentId: selectedSegment.id }
          : { filters: buildUIFilters(filterGroups) };

        if (customer.shouldEncryptPI) {
          await api.exportEncryptedCustomerAllContacts({
            customerId,
            userEmail: userMail,
            isFromExportButton: true,
            ...targetParams,
          });
        } else {
          await api.exportAllContacts({
            customerId,
            userEmail: userMail,
            ...targetParams,
          });
        }
      },
    });
  }

  return exportActions;
};
